import React, { FC, PropsWithChildren, useMemo } from "react"
import semver, { SemVer } from "semver"
import { DeviceDocument, useDevices } from "../../../../contexts/devices-context"
import { Box, Overlay } from "@mantine/core"

type RequiresVersionProps = {
    device: DeviceDocument | undefined
    group: string
    version: string | SemVer
}

const dashboardIsDev = (process.env.NODE_ENV == "development");
const deviceIsDev = (device) => device?.health?.version === "1.0.0.dev0"
const deviceVersionGt = (device, version) => (
    (device?.health?.semver_version !== undefined && semver.gte(device?.health?.semver_version, version)) ?? false
)

function deviceHasMinVersion(device: DeviceDocument | undefined, version: string | SemVer): boolean {
    return dashboardIsDev || deviceVersionGt(device, version)  || deviceIsDev(device)
}

function allDevicesInGroupHaveMinVersion(group: string, version: string | SemVer) {
    const { data } = useDevices()
    const devices = useMemo(() => data.filter(device => device.group === group), [data, group])
    return dashboardIsDev || devices.every(device => deviceHasMinVersion(device, version))
}

const RequiresVersion: FC<PropsWithChildren<RequiresVersionProps>> = ({ device, group, version, children, hide = false }) => {
    if ((device === undefined && allDevicesInGroupHaveMinVersion(group, version)) || deviceHasMinVersion(device, version) || dashboardIsDev) {
        return <>{children}</>
    } else if (hide) {
        return <></>
    } else {
        const text = <p style={{color: "#fff"}}>{`requires client version >= v${version}`}</p>
        return <Box p="10px" pos="relative"><Overlay radius="md" opacity={0.5} children={text} center={true} />{children}</Box>
    }
}

export default RequiresVersion